"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiptProof = exports.index2key = exports.prepareBlock = exports.getBlockchainHeader = exports.getRegistryContract = exports.signBlock = exports.getRlpHeader = void 0;
var ethers = __importStar(require("ethers"));
var BlockHeaderRegistry_json_1 = require("./abi/BlockHeaderRegistry.json");
var lodash_1 = require("lodash");
var providers_1 = require("@ethersproject/providers");
var merkle_patricia_tree_1 = __importDefault(require("merkle-patricia-tree"));
var eth_object_1 = require("eth-object");
var eth_util_lite_1 = require("eth-util-lite");
var promisfy_1 = require("promisfy");
var RLP = __importStar(require("rlp"));
var rpcs = {};
function getRlpHeader(web3Header) {
  var rlpBytes = (0, lodash_1.flatten)(Object.entries(web3Header).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    if (!v || v === '0x' || v === '0x0') return '0x';
    if (k === 'sealFields') return v.map(function (_) {
      return ethers.utils.RLP.decode(_);
    });
    return v;
  }));
  var rlpHeader = '0x' + RLP.encode(rlpBytes).toString('hex');
  return rlpHeader;
}
exports.getRlpHeader = getRlpHeader;
function signBlock(_x, _x2, _x3, _x4, _x5) {
  return _signBlock.apply(this, arguments);
}
function _signBlock() {
  _signBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(rlpHeader, chainId, signer, cycleEnd, validators) {
    var blockHash, packed, payload, signature;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          blockHash = ethers.utils.keccak256(rlpHeader);
          packed = ethers.utils.solidityPack(['bytes32', 'uint256', 'address[]', 'uint256'], [blockHash, chainId, validators, cycleEnd]);
          payload = ethers.utils.keccak256(packed);
          _context4.t0 = ethers.utils;
          _context4.next = 6;
          return signer.signMessage(ethers.utils.arrayify(payload));
        case 6:
          _context4.t1 = _context4.sent;
          signature = _context4.t0.splitSignature.call(_context4.t0, _context4.t1);
          return _context4.abrupt("return", {
            rlpHeader: rlpHeader,
            blockHash: ethers.utils.keccak256(rlpHeader),
            chainId: Number(chainId),
            signature: {
              r: signature.r,
              vs: signature._vs
            },
            cycleEnd: cycleEnd,
            validators: validators
          });
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _signBlock.apply(this, arguments);
}
exports.signBlock = signBlock;
var getRegistryContract = function getRegistryContract(address, signer) {
  return new ethers.Contract(address, BlockHeaderRegistry_json_1.abi, signer);
};
exports.getRegistryContract = getRegistryContract;
var getBlockchainHeader = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(blockTag, chainId, rpc) {
    var web3, block;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          web3 = rpcs[String(chainId)] || new providers_1.JsonRpcBatchProvider(rpc);
          rpcs[String(chainId)] = web3;
          _context.next = 4;
          return web3.send('eth_getBlockByNumber', [blockTag === 'latest' ? 'latest' : '0x' + Number(blockTag).toString(16), false]);
        case 4:
          block = _context.sent;
          return _context.abrupt("return", (0, exports.prepareBlock)(block, chainId));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getBlockchainHeader(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
exports.getBlockchainHeader = getBlockchainHeader;
var prepareBlock = function prepareBlock(block, chainId) {
  var header = (0, lodash_1.pick)(block, ['parentHash', 'sha3Uncles', 'miner', 'stateRoot', 'transactionsRoot', 'receiptsRoot', 'logsBloom', 'difficulty', 'number', 'gasLimit', 'gasUsed', 'timestamp', 'extraData', 'sealFields', 'step', 'signature', 'mixHash', 'nonce', 'baseFeePerGas']);
  if (chainId === 42220) {
    delete header['gasLimit'];
    delete header['baseFeePerGas'];
    var istanbulExtra = ethers.utils.RLP.decode('0x' + header.extraData.slice(66));
    istanbulExtra[4] = ['0x', '0x', '0x'];
    var cleanExtra = ethers.utils.RLP.encode(istanbulExtra);
    header.extraData = header.extraData.slice(0, 66) + cleanExtra.slice(2);
  }
  if (header['sealFields'] && header['step'] && header['signature']) {
    delete header['step'];
    delete header['signature'];
  }
  var rlpHeader = getRlpHeader(header);
  var blockHash = ethers.utils.keccak256(rlpHeader);
  if (blockHash !== block.hash) {
    throw new Error("rlp hash doesnt match expected blockhash ".concat(block.number));
  }
  return {
    block: block,
    blockHeader: header,
    rlpHeader: rlpHeader,
    computedHash: blockHash
  };
};
exports.prepareBlock = prepareBlock;
var index2key = function index2key(index, proofLength) {
  var actualkey = [];
  var encoded = (0, eth_util_lite_1.encode)(index).toString('hex');
  var key = _toConsumableArray(new Array(encoded.length / 2).keys()).map(function (i) {
    return parseInt(encoded[i * 2] + encoded[i * 2 + 1], 16);
  });
  key.forEach(function (val) {
    if (actualkey.length + 1 === proofLength) {
      actualkey.push(val);
    } else {
      actualkey.push(Math.floor(val / 16));
      actualkey.push(val % 16);
    }
  });
  return '0x' + actualkey.map(function (v) {
    return v.toString(16).padStart(2, '0');
  }).join('');
};
exports.index2key = index2key;
var receiptProof = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(txHash, provider, chainId) {
    var targetReceipt, rpcBlock, blockHeader, withReceiptType, blockReceipt, receipts, tree, _yield, _yield2, stack, receiptsRoot;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return provider.send('eth_getTransactionReceipt', [txHash]);
        case 2:
          targetReceipt = _context3.sent;
          if (targetReceipt) {
            _context3.next = 5;
            break;
          }
          throw new Error('txhash/targetReceipt not found. (use Archive node)');
        case 5:
          _context3.next = 7;
          return provider.send('eth_getBlockByHash', [targetReceipt.blockHash, false]);
        case 7:
          rpcBlock = _context3.sent;
          blockHeader = (0, exports.prepareBlock)(rpcBlock, chainId);
          withReceiptType = !!blockHeader.blockHeader.baseFeePerGas || [42220].includes(chainId);
          if (chainId === 42220) {
            blockReceipt = provider.send('eth_getBlockReceipt', [targetReceipt.blockHash]);
          }
          _context3.next = 13;
          return Promise.all(rpcBlock.transactions.map( /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(siblingTxHash) {
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", provider.send('eth_getTransactionReceipt', [siblingTxHash]));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x12) {
              return _ref5.apply(this, arguments);
            };
          }()).concat(blockReceipt));
        case 13:
          receipts = _context3.sent.filter(function (_) {
            return _;
          });
          tree = new merkle_patricia_tree_1.default();
          _context3.next = 17;
          return Promise.all(receipts.map(function (siblingReceipt, index) {
            var siblingPath = (0, eth_util_lite_1.encode)(index);
            var serializedReceipt = eth_object_1.Receipt.fromRpc(siblingReceipt).serialize();
            if (withReceiptType && siblingReceipt.type && siblingReceipt.type != '0x0') {
              serializedReceipt = Buffer.concat([Buffer.from([siblingReceipt.type]), serializedReceipt]);
            }
            return (0, promisfy_1.promisfy)(tree.put, tree)(siblingPath, serializedReceipt);
          }));
        case 17:
          _context3.next = 19;
          return (0, promisfy_1.promisfy)(tree.findPath, tree)((0, eth_util_lite_1.encode)(targetReceipt.transactionIndex));
        case 19:
          _yield = _context3.sent;
          _yield2 = _slicedToArray(_yield, 3);
          stack = _yield2[2];
          receiptsRoot = '0x' + tree.root.toString('hex');
          if (!(receiptsRoot !== blockHeader.block.receiptsRoot)) {
            _context3.next = 26;
            break;
          }
          console.error(receipts, {
            receiptsRoot: receiptsRoot,
            blockReceiptsRoot: blockHeader.block.receiptsRoot
          });
          throw new Error('receiptsRoot mismatch');
        case 26:
          return _context3.abrupt("return", {
            receipt: targetReceipt,
            receiptsRoot: receiptsRoot,
            headerRlp: blockHeader.rlpHeader,
            receiptProof: eth_object_1.Proof.fromStack(stack).raw.map(function (_) {
              return '0x' + (0, eth_util_lite_1.encode)(_).toString('hex');
            }),
            txIndex: targetReceipt.transactionIndex,
            receiptRlp: '0x' + (withReceiptType && targetReceipt.type && targetReceipt.type != '0x0' ? ethers.utils.hexlify(Number(targetReceipt.type)).slice(2) : '') + eth_object_1.Receipt.fromRpc(targetReceipt).serialize().toString('hex')
          });
        case 27:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function receiptProof(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();
exports.receiptProof = receiptProof;